module.exports = __webpack_public_path__ + "media/highclass/service-process-sp-acc75972.svg";